export function toKebabCase(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, "$1-$2") // Add hyphen between camelCase words
    .replace(/[\s_]+/g, "-") // Replace spaces and underscores with hyphens
    .replace(/[?,\\"]/g, "") // Remove special characters
    .toLowerCase(); // Convert to lower case
}

export function toTemplatedString(str: string): string {
  return `$\{{ ${str} }}`;
}
